import React, { memo } from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            Más los <span className="text-[#00C853]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-9">01</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              El Plan Anti-Caos (Calendario de Curso A1→C2 en 30 Min)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              Transformá los 6 tomos en un plan anual listo en 30 minutos.
              Incluye 4 calendarios (1/2/3 clases por semana + intensivo),
              semana tipo para 45/60/90 min, tabla Unidad→Objetivo→Evidencia,
              Plan B para imprevistos y Checklist de armado del curso.
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">$8.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-17">02</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              Banco de Situaciones Reales (20 Roleplays Listos para Hablar
              Italiano)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              Los 20 roleplays más efectivos del aula de italiano: Al bar, En la
              estación, Dal medico, Colloquio di lavoro, Affitto apartamento,
              Debate Smart Working y 14 más. Con rúbrica express de speaking,
              frases puente y tarjetas imprimibles.
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">
                $10.000
              </span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-25">03</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              Kit Niveles Mixtos (La Clase Funciona Aunque Tengas A2+B1 Juntos)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              5 modelos de clase probados para grupos heterogéneos + plantillas
              A/B/C por nivel + scripts de conversación con el alumno +
              diagnóstico express en 5 minutos + Regla 70/20/10. Para las
              combinaciones más frecuentes: A2+B1, B1+B2, 3 niveles juntos.
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-33">04</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              Scripts Profe Seguro (Italiano de Aula para Dar Clase Sin Dudar)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              100+ frases listas para dirigir, corregir y motivar completamente
              en italiano: Apertura, Transiciones, Instrucciones, Corrección
              elegante, Motivación, Disciplina elegante, Trabajo grupal,
              Verifiche y Cierre. Con 12 tarjetas imprimibles y checklist
              semanal de incorporación.
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">$8.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-41">05</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              Pack Errores Típicos (Corrección Inteligente A1→C2 sin Frustrar)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              Los errores más frecuentes por nivel con el Framework de 20
              segundos: Qué dijo / Qué debería / La regla / El ejemplo. Incluye
              tablas maestras A1→C2, errores de interferencia español-italiano,
              3 estilos de feedback, códigos de corrección express y fichas de
              registro del alumno.
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-49">06</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              Sistema Clase Brillante (Cómo Hacer que el PDF se Sienta Premium
              en el Aula)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              El Sistema 3C (Calentar→Construir→Cerrar) + 10 aperturas rápidas +
              5 dinámicas de práctica + 10 cierres memorables + plantillas guion
              para 45/60/90 minutos. Para que cada clase se sienta profesional y
              dinámica, no una fotocopia.
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#00C853]/40 rounded-2xl p-6 text-center bg-[#000d08]" data-id="element-56">
          <p className="text-[#00C853] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$53.000</span>
            <span className="text-[#00C853] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Solo con tu MegaPack
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}